import React, { useState } from 'react';
import SupportFormModal from '../../components/support/SupportFormModal';

export default function SipDomainRequestCard({ tenantName = '', tenantId = '' }) {
  const [open, setOpen] = useState(false);
  const label = tenantName || 'This tenant';

  return (
    <div className="bg-white border border-gray-300 shadow-md rounded-lg p-6 max-w-xl">
      <h2 className="text-lg font-semibold text-gray-900">No SIP domain is assigned</h2>
      <p className="mt-2 text-sm text-gray-600">
        {label} does not have a SIP domain yet. Contact Signal Bridge support and ask for a domain to be assigned.
      </p>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className="mt-4 inline-flex items-center rounded-md bg-blue-600 px-4 py-2 text-sm font-medium text-white hover:bg-blue-700"
      >
        Request a domain
      </button>
      <SupportFormModal
        isOpen={open}
        onClose={() => setOpen(false)}
        initialType="account"
        initialTitle={`Assign a SIP domain to ${label}`}
        initialDescription={`Please assign a SIP domain to ${label}${tenantId ? ` (${tenantId})` : ''}. This tenant does not have one yet.`}
      />
    </div>
  );
}
